// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__s8oyW","buttons":"Footer_buttons__sZKZl"};